import { canRunPow } from "./pow";

export function solvePow(params, options = {}) {
  const { salt, difficulty } = params || {};
  const { timeoutMs = 10000, onProgress, signal } = options;
  if (!canRunPow() || !salt || !difficulty) {
    return Promise.resolve(null);
  }
  return new Promise((resolve) => {
    let settled = false;
    const worker = new Worker(new URL("./powWorker.js", import.meta.url));
    const finish = (value) => {
      if (settled) {
        return;
      }
      settled = true;
      clearTimeout(timer);
      if (signal) {
        signal.removeEventListener("abort", onAbort);
      }
      worker.terminate();
      resolve(value);
    };
    const timer = setTimeout(() => finish(null), timeoutMs);
    const onAbort = () => finish(null);
    if (signal) {
      signal.addEventListener("abort", onAbort, { once: true });
    }
    worker.onmessage = (event) => {
      if (event.data && event.data.progress != null) {
        if (onProgress) {
          onProgress(event.data.progress);
        }
        return;
      }
      finish(event.data && event.data.nonce != null ? event.data.nonce : null);
    };
    worker.onerror = () => finish(null);
    worker.postMessage({ salt, difficulty });
  });
}
